// import {environment} from '../../environment/environment';
import { CONFIG } from 'src/config-global';
import { environment } from 'src/environment/environment';
import ServiceRequest from '../ServiceRequest';
import {
  LoginResponseMapper,
  SignupParams,
  SignupResponseMapper,
  VerifyAccountParams,
  VerifyAccountResponseMapper,
  CreatePasswordParams,
  CreatePasswordResponseMapper,
  ForgetPasswordParams,
  ForgetPasswordResponseMapper,
  ResetPasswordParams,
  ResetPasswordResponseMapper,
  LoginWithAzureParams,
  FeedbackResponse,
} from '../service-mappers/PublicServiceMapper';

export const loginUrl =
  CONFIG.baseUrl + CONFIG.apiEndPoints.auth.base + CONFIG.apiEndPoints.auth.login;
export const adminLoginUrl =
  CONFIG.baseUrl + CONFIG.apiEndPoints.auth.base + CONFIG.apiEndPoints.auth.adminLogin;
export const signUpUrl =
  CONFIG.baseUrl + CONFIG.apiEndPoints.auth.base + CONFIG.apiEndPoints.auth.signup;
export const forgetPasswordUrl =
  CONFIG.baseUrl + CONFIG.apiEndPoints.auth.base + CONFIG.apiEndPoints.auth.forgetPassword;
export const appBaseUrl = CONFIG.baseUrl;
// export const verifyUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.verifyUser;
// export const createPasswordUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.createPassword;
// export const forgetPasswordUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.forgetPassword;
// export const resetPasswordUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.resetPassword;

// export const LDAPLoginUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.LDAPLogin;

// export const azureLoginUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.azureLogin;

// export const epicLoginUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.epicLogin;

// export const feedbackUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.feedback;

// export const versionUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.versioninfo;

// export const EnvConfigUrl =
//   environment.baseUrl +
//   environment.apiEndPoints.auth.base +
//   environment.apiEndPoints.auth.envConfig;

export const sendOtp = async (values: any): Promise<any> => {
  const url = `${appBaseUrl}/auth/otp/send`;
  return ServiceRequest.post(url, { payload: values });
};

export const verifyOtp = async (values: any): Promise<any> => {
  const url = `${appBaseUrl}/auth/otp/verify`;
  return ServiceRequest.post(url, { payload: values });
};

export const checkUserName = async (values: any): Promise<any> => {
  const url = `${appBaseUrl}/auth/username/check`;
  return ServiceRequest.post(url, { payload: values });
};

export const azureLoginService = async (data: LoginWithAzureParams): Promise<any> =>
  ServiceRequest.post(`${appBaseUrl}/auth/azure/login`, { payload: data });
// export const LDAPloginService = async (
//   values: any
// ): Promise<LoginResponseMapper> => {
//   return await ServiceRequest.post(LDAPLoginUrl, {payload: values});
// };

export const loginService = async (values: any): Promise<LoginResponseMapper> => {
  return ServiceRequest.post(loginUrl, { payload: values });
};
export const getUserEmail = async (values: any): Promise<any> => {
  return ServiceRequest.post(loginUrl, { payload: values });
};

export const adminLoginService = async (values: any): Promise<LoginResponseMapper> => {
  return ServiceRequest.post(adminLoginUrl, { payload: values });
};

export const signUpService = async (values: any): Promise<SignupResponseMapper> =>
  ServiceRequest.post(signUpUrl, { payload: values });

export const forgetPasswordService = async (values: any): Promise<any> => {
  return ServiceRequest.post(forgetPasswordUrl, { payload: values });
};

export const getWaitlistTotals = async (): Promise<any> =>
  ServiceRequest.get(`${appBaseUrl}/waitlist/get_waitlist_count`);

export const getAffordableWaitlist = async (values: any): Promise<any> =>
  ServiceRequest.post(`${appBaseUrl}/waitlist/get_waitlist_table`, { payload: values });

export const getListData = async (values: any): Promise<any> =>
  ServiceRequest.post(`${appBaseUrl}/admin/getModuleListData`, { payload: values });

export const getAffordableStanding = async (values: any): Promise<any> =>
  ServiceRequest.post(`${appBaseUrl}/waitlist/get_affordable_standing`, { payload: values });

export const getAttainableStanding = async (values: any): Promise<any> =>
  ServiceRequest.post(`${appBaseUrl}/waitlist/get_attainable_standing`, { payload: values });

// Public endpoint to get landing page hero text (no authentication required)
// lang: 'en' | 'es' — client-selected language; default from API is 'en'
export const getLandingPageHeroText = async (lang?: 'en' | 'es'): Promise<any> =>
  ServiceRequest.get(`${appBaseUrl}/public/landing-page-hero-text`, lang != null ? { payload: { lang } } : undefined);

// Public endpoint to get program qualifications text (no authentication required)
export const getProgramQualificationsText = async (lang?: 'en' | 'es'): Promise<any> =>
  ServiceRequest.get(`${appBaseUrl}/public/program-qualifications-text`, lang != null ? { payload: { lang } } : undefined);

// Public endpoint to get waitlist process text (no authentication required)
export const getWaitlistProcessText = async (lang?: 'en' | 'es'): Promise<any> =>
  ServiceRequest.get(`${appBaseUrl}/public/waitlist-process-text`, lang != null ? { payload: { lang } } : undefined);

// Public endpoint to get help URL and label for both languages (no auth). Call once; client picks en/es by currentLang.
export const getHelpUrl = async (): Promise<{
  en: { url: string; label: string };
  es: { url: string; label: string };
}> => ServiceRequest.get(`${appBaseUrl}/public/help-url`);

// Public endpoint to get background images (no authentication required)
export const getBackgroundImages = async (): Promise<any> =>
  ServiceRequest.get(`${appBaseUrl}/public/background-images`);

// export const verifyAccountService = async (
//   values: VerifyAccountParams
// ): Promise<VerifyAccountResponseMapper> => {
//   return await ServiceRequest.post(verifyUrl, {payload: values});
// };

// export const createPasswordService = async (
//   values: CreatePasswordParams
// ): Promise<CreatePasswordResponseMapper> => {
//   return await ServiceRequest.post(createPasswordUrl, {payload: values});
// };

// export const resetPasswordService = async (
//   values: ResetPasswordParams
// ): Promise<ResetPasswordResponseMapper> => {
//   return await ServiceRequest.post(resetPasswordUrl, {payload: values});
// };

// export const forgetPasswordService = async (
//   values: ForgetPasswordParams
// ): Promise<ForgetPasswordResponseMapper> => {
//   return await ServiceRequest.post(forgetPasswordUrl, {payload: values});
// };

// export const epicLoginService = async (
//   values: any
// ): Promise<LoginResponseMapper> => {
//   return await ServiceRequest.post(epicLoginUrl, {payload: values});
// };

// export const feedbackService = async (
//   values: any
// ): Promise<FeedbackResponse> => {
//   return await ServiceRequest.post(feedbackUrl, {payload: values});
// };

// export const VersionData = async (): Promise<any> => {
//   return ServiceRequest.get(versionUrl);
// };
// export const ENVConfigData = async (): Promise<any> => {
//   return ServiceRequest.get(EnvConfigUrl);
// };
